var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client)?_c('div',{staticClass:"field-list"},_vm._l((_vm.infoData),function(info){return _c('div',{key:info.label,staticClass:"field-row"},[_c('span',{staticClass:"field-lbl"},[_vm._v(_vm._s(info.label))]),_c('span',{staticClass:"field-val"},[_vm._v(_vm._s(info.value))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }